import { render, staticRenderFns } from "./VSelectbox.vue?vue&type=template&id=2f6ee165&scoped=true&"
import script from "./VSelectbox.vue?vue&type=script&lang=js&"
export * from "./VSelectbox.vue?vue&type=script&lang=js&"
import style0 from "./VSelectbox.vue?vue&type=style&index=0&id=2f6ee165&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6ee165",
  null
  
)

export default component.exports